import React from 'react';
import { Helmet } from 'react-helmet-async';
import { SocialIcon } from 'react-social-icons';
import AuditedHeroSection from '../../components/audited/AuditedHeroSection';
import SocialProofBar from '../../components/audited/SocialProofBar';
import AuditedCoursesSection from '../../components/audited/AuditedCoursesSection';
import AuditedWhyUsSection from '../../components/audited/AuditedWhyUsSection';
import AuditedTeachersSection from '../../components/audited/AuditedTeachersSection';
import AuditedPricingSection from '../../components/audited/AuditedPricingSection';
import AuditedTestimonialsSection from '../../components/audited/AuditedTestimonialsSection';
import AuditedFAQSection from '../../components/audited/AuditedFAQSection';
import ContactSection from '../../components/ContactSection';
import StickyFooterCTA from '../../components/audited/StickyFooterCTA';

const AuditedHomePage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Sigma Study - Zdaj Mature z Matematyki Bez Stresu | Korepetycje Online</title>
        <meta name="description" content="Sigma Study - 98% uczniow zdaje mature powyzej oczekiwan! Profesjonalne korepetycje z matematyki online. Sredni wzrost wynikow o 35 punktow w 8 tygodni." />
        <link rel="canonical" href="https://sigmastudy.pl/audited" />
      </Helmet>

      <AuditedHeroSection />
      <SocialProofBar />
      <AuditedCoursesSection />
      <AuditedWhyUsSection />
      <AuditedTeachersSection />
      <AuditedPricingSection />
      <AuditedTestimonialsSection />
      <AuditedFAQSection />
      <ContactSection />
      <StickyFooterCTA />

      <footer className="footer">
        <div className="footer-container">
          <div className="footer-content">
            <div className="footer-section">
              <div className="footer-logo">
                <img
                  src="/logo_sigma/SVG/white.svg"
                  alt="Sigma Study School Logo"
                  className="footer-logo-img"
                />
              </div>
            </div>

            <div className="footer-section no-hover">
              <h4>Zajecia</h4>
              <ul>
                <li>Szkola Podstawowa</li>
                <li>Matematyka Gimnazjalna</li>
                <li>Matematyka Liceum</li>
                <li>Przygotowanie do Matury</li>
              </ul>
            </div>

            <div className="footer-section">
              <h4>Kontakt</h4>
              <p>Tel: +48 532 533 220</p>
              <p>Email: info@sigma-study.net</p>
            </div>

            <div className="footer-section">
              <h4>Nasze social media</h4>
              <div className="social-links">
                <div style={{ display: 'flex', gap: '12px' }}>
                  <SocialIcon url="https://www.facebook.com/people/Sigma-Study/61576967721817/" style={{ height: 35, width: 35 }} />
                  <SocialIcon url="https://www.instagram.com/sigma_study_/" style={{ height: 35, width: 35 }} />
                </div>
              </div>
            </div>
          </div>

          <div className="footer-bottom">
            <p>2026 Wszystkie prawa zastrzezone.</p>
            <div className="footer-links">
              <a href="/polityka-prywatnosci">Polityka prywatnosci</a>
              <a href="/regulamin">Regulamin</a>
              <a href="/cookies">Cookies</a>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default AuditedHomePage;
